import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    messageInputWrapper: {
      alignItems: 'flex-start',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      background: palette.white,
      [children('.str-chat__textarea')]: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      },
      [children('.str-chat__textarea textarea')]: {
        border: 'none',
        fontSize: 17,
        borderRadius: 12,
        lineHeight: '160%',
        background: 'rgba(0, 0, 0, 0)',
      },
      [children('.str-chat__textarea textarea::placeholder')]: {
        color: 'rgba(0, 0, 0, 0.2)',
      },
      [children('.str-chat__textarea textarea:focus')]: {
        border: 'none',
        boxShadow: 'none',
      },
      [children('svg:hover')]: {
        cursor: 'pointer',
      },
      [children('div.rfu-dropzone:focus')]: {
        outline: 'none',
      },
      [children('.rfu-image-previewer')]: {
        flex: 'none',
        marginLeft: 12,
      },
      [children('.rfu-image-previewer__image')]: {
        marginBottom: 0,
      },
      [children('div')]: {
        width: '100%',
      },
    },
    messageInputInput: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      border: `1px solid ${palette.lightGrey}`,
      borderRadius: 12,
      background: 'rgba(0,0,0,.05)',
      ':focus': {
        outline: 'none',
      },
      ':focus-within': {
        borderColor: '#005fff',

        [children('svg > path')]: {
          fill: '#005fff',
          fillOpacity: 1,
        },
      },
    },

    messageInputInputWrapper: {
      display: 'flex',
      fontSize: 27,
      color: palette.white,
      marginBottom: 5,
      alignItems: 'center',
    },
    messageInputSendButton: {
      background: 'none',
      border: 'none',
      display: 'flex',
    },
  });
};
